<template>
  <v-container
    v-if="order"
  >
    <validation-observer ref="orderAcceptsPickupValidator">
      <v-card
        flat
        class="mb-5"
      >
        <v-card-text>
          <!-- 売上計上しない -->
          <v-row
            v-if="isBilling"
          >
            <v-col cols="12">
              <v-checkbox
                v-model="order.not_recorded_sales"
                dense
                label="売上計上しない"
                hide-details="auto"
              >
              </v-checkbox>
            </v-col>
          </v-row>
          <!-- /売上計上しない -->

          <!-- 営業担当者 -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                name="営業担当者"
                rules="max:12"
              >
                <v-combobox
                  v-model="order.sales_staff"
                  :error-messages="errors"
                  :items="salesStaffs"
                  :return-object="false"
                  dense
                  label="営業担当者"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>営業担当者</span>
                    <span class="ml-1">
                      ({{ order.sales_staff?.length || 0 }} / 12)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /営業担当者 -->

          <!-- 依頼元業者 -->
          <div v-if="false">
            selectedTraderId: {{ selectedTraderId }} <br />
            request_trader_id: {{ order.request_trader_id }} <br />
            trader_location_id: {{ order.trader_location_id }} <br />
            trader_location_code: {{ order.trader_location_code }}<br />
          </div>
          <infinite-trader-and-location-auto-complete
            id="request_trader"
            :trader-id="order.request_trader_id"
            :location-id="order.trader_location_id"
            :location-code="order.trader_location_code"
            :trader-required="true"
            :location-required="true"
            :without-invisible="true"
            trader-label="依頼元業者"
            location-label="引取場所"
            trader-md="6"
            location-md="5"
            location-auto-select
            search-type="transport"
            @update:values="requestTraderChangedCallback"
          >
            <template v-slot:trader-append-outer>
              <choose-trader-button
                :small-button="true"
                :search-type="`transport`"
                :button-caption="`依頼元業者を選択`"
                :without-invisible="true"
                @choseTraderCallback="choseRequestTraderCallback"
              />
            </template>
            <template v-slot:location-item="slotProps">
              <v-chip
                :title="slotProps.item?.code"
                color="#e0ffff"
                label
                small
              >
                {{ slotProps.item?.code }}
              </v-chip>
              &nbsp;{{ slotProps.item.text }}
              <small class="text--disabled">{{ slotProps.item.address }}</small>
            </template>
          </infinite-trader-and-location-auto-complete>
          <v-row v-if="selectedTransport || selectedTraderLocation" dense>
            <v-col cols="12" md="6" class="mt-0 pt-0">
              <div v-if="selectedTransport" class="ml-2">
                <div>
                  〒{{ selectedTransport.zip_code }}&emsp;{{ selectedTransport.address }}
                </div>
                <div>
                  電話番号:{{ selectedTransport.phone_number || '-' }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="5" class="mt-0 pt-0">
              <div v-if="selectedTraderLocation" class="ml-2">
                <div>
                  〒{{ selectedTraderLocation.zip_code }}&emsp;{{ selectedTraderLocation.address }}
                </div>
                <div>
                  電話番号:{{ selectedTraderLocation.phone_number || '-' }}
                </div>
              </div>

            </v-col>
          </v-row>
          <!-- /依頼元業者 -->

          <!-- 運搬先/運搬先事業場 -->
          <infinite-trader-and-location-auto-complete
            id="trader"
            :trader-id="order.trader_id"
            :location-id="order.to_trader_location_id"
            :location-code="order.to_trader_location_code"
            :trader-required="true"
            :location-required="true"
            :without-invisible="true"
            trader-md="6"
            location-md="5"
            trader-label="運搬先事業者"
            location-label="運搬先事業場"
            search-type="either"
            location-auto-select
            @update:values="toTraderChangedCallback"
          >
            <template v-slot:trader-append-outer>
              <choose-trader-button
                :small-button="true"
                :button-caption="`運搬先事業者を選択`"
                :without-invisible="true"
                @choseTraderCallback="choseTraderCallback"
              />
            </template>
            <template v-slot:location-item="slotProps">
              <v-chip
                :title="slotProps.item?.code"
                color="#e0ffff"
                label
                small
              >
                {{ slotProps.item?.code }}
              </v-chip>
              &nbsp;{{ slotProps.item.text }}
              <small class="text--disabled">{{ slotProps.item.address }}</small>
            </template>
          </infinite-trader-and-location-auto-complete>
          <v-row v-if="selectedTrader || selectedToTraderLocation" dense>
            <v-col cols="12" md="6" class="mt-0 pt-0">
              <div v-if="selectedTrader" class="ml-2">
                <div>
                  〒{{ selectedTrader.zip_code }}&emsp;{{ selectedTrader.address }}
                </div>
                <div>
                  電話番号:{{ selectedTrader.phone_number || '-' }}
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="5" class="mt-0 pt-0">
              <div v-if="selectedToTraderLocation" class="ml-2">
                <div>
                  〒{{ selectedToTraderLocation.zip_code }}&emsp;{{ selectedToTraderLocation.address }}
                </div>
                <div>
                  電話番号:{{ selectedToTraderLocation.phone_number || '-' }}
                </div>
              </div>

            </v-col>
          </v-row>
          <!-- /運搬先/運搬先事業場 -->

          <!-- 積替運搬日, 希望時間 -->
          <v-row>
            <v-col cols="12" md="3">
              <cs-date-picker
                :date.sync="order.plan_date"
                @dateChangedCallback="planDateChangedCallback"
              >
                <template v-slot="{ on, attrs }">
                  <validation-provider
                    v-slot="{ errors }"
                    :rules="{ required: !(order.plan_date) }"
                    name="積替運搬日"
                    class="requiredMark"
                  >
                    <v-text-field
                      v-model="order.plan_date"
                      v-bind="attrs"
                      v-on="on"
                      :error-messages="errors"
                      append-icon="mdi-calendar"
                      clearable
                      dense
                      hide-details="auto"
                      label="積替運搬日"
                      outlined
                      persistent-hint
                      persistent-placeholder
                      readonly
                    />
                  </validation-provider>
                </template>
              </cs-date-picker>
            </v-col>
            <!-- /積替運搬頼日 -->
            <!-- 希望時間 -->
            <v-col cols="12" md="2">
              <validation-provider
                v-slot="{ errors }"
                :rules="{preferredStartTimeCheck: {preferred_end_time: order.plan_end_time}}"
                name="希望開始時間"
              >
                <vue-ctk-date-time-picker
                  v-model="order.plan_start_time"
                  minute-interval="15"
                  no-value-to-custom-elem
                  only-time
                  color="#0070B3"
                  format="HH:mm"
                  formatted="HH:mm"
                >
                  <v-text-field
                    v-model="order.plan_start_time"
                    :error-messages="errors"
                    append-icon="mdi-clock-time-four-outline"
                    clearable
                    dense
                    hide-details="auto"
                    label="希望開始時間"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    placeholder="--:--"
                    readonly
                  />
                </vue-ctk-date-time-picker>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="2">
              <vue-ctk-date-time-picker
                v-model="order.plan_end_time"
                minute-interval="15"
                color="#0070B3"
                format="HH:mm"
                formatted="HH:mm"
                only-time
                no-value-to-custom-elem
              >
                <v-text-field
                  v-model="order.plan_end_time"
                  append-icon="mdi-clock-time-four-outline"
                  clearable
                  outlined
                  label="希望終了時間"
                  dense
                  persistent-placeholder
                  hide-details="auto"
                  placeholder="--:--"
                  readonly
                />
              </vue-ctk-date-time-picker>
            </v-col>
          </v-row>
          <!-- 積替運搬日, 希望時間 -->

          <!-- 運搬担当者／運搬方法／車両番号 -->
          <v-row>
            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`transport_user_name`"
                :rules="{ max: 12 }"
                name="運搬担当者"
              >
                <v-combobox
                  v-model="order.transport_user_name"
                  :error-messages="errors"
                  :items="drivers"
                  :return-object="false"
                  clearable
                  dense
                  hide-details="auto"
                  item-value="text"
                  label="運搬担当者"
                  outlined
                  persistent-placeholder
                  @click:clear="transportUserClearClickEvent"
                  @change="transportUserChangeEvent"
                >
                  <template v-slot:label>
                    <span>運搬担当者</span>
                    <span class="ml-1">
                      ({{ order.transport_user_name?.length || 0 }} / 12)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>

            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`transportation_id`"
                name="運搬方法"
              >
                <v-select
                  v-model="order.transportation_id"
                  :error-messages="errors"
                  :items="transportations"
                  dense
                  clearable
                  hide-details="auto"
                  label="運搬方法"
                  outlined
                  persistent-placeholder
                ></v-select>
              </validation-provider>
            </v-col>

            <v-col cols="12" md="4">
              <validation-provider
                v-slot="{ errors }"
                :vid="`vehicle_number`"
                name="車両番号"
                rules="max:15"
              >
                <v-combobox
                  v-model="order.vehicle_number"
                  :error-messages="errors"
                  :items="vehicles"
                  :return-object="false"
                  :clearable="true"
                  item-text="number"
                  item-value="number"
                  dense
                  label="車両番号"
                  hide-details="auto"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>車両番号</span>
                    <span class="ml-1">
                      ({{ order.vehicle_number?.length || 0 }} / 15)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-combobox>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /運搬担当者／運搬方法／車両番号 -->

          <!-- ドライバー指示メモ -->
          <v-row>
            <v-col cols="12" :md="driverInstructionMd">
              <validation-provider
                v-slot="{ errors }"
                name="ドライバー指示メモ"
                rules="max:300"
              >
                <v-textarea
                  v-model="order.driver_instruction"
                  :error-messages="errors"
                  hide-details="auto"
                  label="ドライバー指示メモ"
                  no-resize
                  outlined
                  persistent-placeholder
                  required
                  rows="2"
                >
                  <template v-slot:label>
                    <span>ドライバー指示メモ</span>
                    <span class="ml-1">
                      ({{ order.driver_instruction?.length || 0 }} / 300)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-textarea>
              </validation-provider>
            </v-col>
            <!-- /ドライバー指示メモ -->

            <!-- 添付ファイル -->
            <v-col cols="12" md="3">
              <dropzone-file
                :max-size="MANIFEST_ATTACHMENT.MAX_SIZE"
                :accepts="MANIFEST_ATTACHMENT.ACCEPTS"
                :max-file-size="MANIFEST_ATTACHMENT.MAX_FILE_SIZE"
                :alt-file-size-format="MANIFEST_ATTACHMENT.ALT_FILE_SIZE_FORMAT"
                :alt-file-format="MANIFEST_ATTACHMENT.ALT_FILE_FORMAT"
                :immediate-delete="MANIFEST_ATTACHMENT.IMMEDIATE_DELETE"
                :files.sync="files"
                :hide-thumbnail="true"
                :simple="true"
                :hide-in-max-file="false"
              />
            </v-col>
            <v-col cols="12" :md="attachmentViewerMd">
              <viewer
                v-if="activeFiles.length > 0"
                :images="activeFiles"
                :options="viewerOptions"
                class="images clearfix"
              >
                <template v-slot="scope">
                  <figure class="images" style="display: flex; flex-wrap: wrap; gap: 8px;">
                    <template
                      v-for="(attachment, index) in scope.images"
                    >
                      <div
                        v-if="!attachment._destroy"
                        :key="attachment.id || attachment.url || index"
                        class="image-wrapper"
                        style="border: 1px solid #ddd;border-radius: 5px;position: relative;width: 100px;min-width: 100px;max-width: 100px;text-align: center;height: 67px;flex-shrink: 0;"
                      >
                        <div style="position: absolute;top: -10px;right: -10px;z-index:100;">
                          <v-btn
                            color="error"
                            icon
                            @click="removeFile(attachment)"
                          >
                            <v-icon>mdi-close-circle</v-icon>
                          </v-btn>
                        </div>
                        <img
                          v-if="isImageContent(attachment.content_type)"
                          :alt="index"
                          :data-source="attachment.url"
                          :src="attachment.url"
                          class="image"
                          style="width: 100%;height: 100%;object-fit: contain;"
                        >
                        <template
                          v-else
                        >
                          <div class="text-center">
                            <v-icon
                              size="65"
                            >
                              {{ documentIcon(attachment.content_type) }}
                            </v-icon>
                          </div>
                        </template>
                      </div>
                    </template>
                    <br style="clear: both;" />
                  </figure>
                </template>
              </viewer>
            </v-col>
          </v-row>
          <!-- /添付ファイル -->

          <!-- 検索キーワード -->
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                v-slot="{ errors }"
                name="検索キーワード"
                rules="max:25"
              >
                <v-text-field
                  v-model="order.keyword"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="検索キーワード"
                  outlined
                  persistent-placeholder
                >
                  <template v-slot:label>
                    <span>検索キーワード</span>
                    <span class="ml-1">
                      ({{ order.keyword?.length || 0 }} / 25)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /検索キーワード -->

          <v-card-actions
            v-if="isBilling && !order.not_recorded_sales"
            class="mt-3"
          >
            <validation-provider
              v-slot="{ errors }"
              class="requiredMark"
              name="受注情報"
              rules="required"
            >
              <v-input
                :value="filteredSalesItems.length > 0 ? 1 : null"
                :error-messages="errors"
                dense
                label="受注情報"
                hide-details="auto"
                outlined
              />
            </validation-provider>
            <v-spacer />
            <v-btn
              :disabled="!order.request_trader_id"
              class="primary"
              @click="showSalesDialogButtonClickEvent"
            >
              追加
            </v-btn>
          </v-card-actions>
          <!-- 受注情報 -->
          <v-row v-if="isBilling && !order.not_recorded_sales">
            <v-col cols="12">
              <v-data-table
                :headers="salesTableHeaders"
                :items="filteredSalesItems"
                :items-per-page="-1"
                disable-pagination
                disable-sort
                hide-default-footer
              >
                <!-- 売上品目コード -->
                <template v-slot:[`item.sales_item_code`]="{item}">
                  <span v-if="item.amount_of_acceptance && item.amount_of_acceptance_unit_name">{{ item.sales_item_code }}</span>
                </template>
                <!-- /売上品目コード -->
                <!-- 受入量 -->
                <template v-slot:[`item.amount_of_acceptance`]="{item}">
                  <span v-if="item.amount_of_acceptance && item.amount_of_acceptance_unit_name">{{ parseFloat(item.amount_of_acceptance) | comma_format }}&nbsp;{{ item.amount_of_acceptance_unit_name }}</span>
                </template>
                <!-- /受入量 -->
                <template v-slot:[`item.editable`]="{ item }">
                  <v-btn
                    class="info mr-1"
                    small
                    @click="editButtonClickEvent(item)"
                  >
                    編集
                  </v-btn>
                  <v-btn
                    class="error"
                    small
                    @click="deleteButtonClickEvent(item)"
                  >
                    削除
                  </v-btn>
                </template>
              </v-data-table>
              <hr>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr>
                      <th class="text-right" width="22.2%">受入量合計</th>
                      <td class="text-right" width="22.2%"></td>
                      <td class="text-right" width="22.2%">
                        <span v-if="totalAmountOfAcceptance > 0">{{ totalAmountOfAcceptance | comma_format }}&nbsp;{{ acceptanceUnitName }}</span>
                        <span v-else>ー</span>
                      </td>
                      <td width="33.4%"></td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <!-- /受注情報 -->
        </v-card-text>
      </v-card>
    </validation-observer>
    <v-card-actions>
      <v-spacer />
      <v-btn
        @click="cancelButtonClickEvent"
      >
        閉じる
      </v-btn>
      <v-btn
        class="primary"
        @click="registerButtonClickEvent"
      >
        受注登録
      </v-btn>
    </v-card-actions>

    <sales-item-dialog
      :enable-dialog="enableSalesItemDialog"
      :sales-item-prices="salesItemPrices"
      :sales-item="selectedSalesItem"
      :sales-item-units="salesItemUnits"
      @cancelCallback="dialogCancelCallback"
      @registerCallback="dialogRegisterCallback"
    />
    <registration-provisional-dialog
      :enable-dialog="enableRegistrationProvisionalDialog"
      :enable-to-deal-button="!order.not_recorded_sales"
      :from-collection-request="false"
      :repeatSetting="'unuse_repeat'"
      @closeCallback="registrationProvisionalDialogCloseCallback"
      @registerCallback="registrationProvisionalRegisterCallback"
    />
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
import { MANIFEST_ATTACHMENT } from '@/constants/appConst'
import DropzoneFile from '../../../../../components/DropzoneFile.vue'
import SalesItemDialog from '../../components/_SalesItemDialog.vue'
import RegistrationProvisionalDialog from '../dialogs/_RegistrationProvisional.vue'
import ChooseTraderButton from "@/driver/components/ChooseTraderButton.vue"
import Confirm from '@/components/Confirm.vue'
import InfiniteTraderAndLocationAutoComplete from "@/driver/components/InfiniteTraderAndLocationAutoComplete.vue";
import { component as Viewer } from 'v-viewer'
import 'viewerjs/dist/viewer.css'

export default {
  name: 'DriverOrderAcceptPickupForm',
  components: {
    DropzoneFile,
    SalesItemDialog,
    RegistrationProvisionalDialog,
    ChooseTraderButton,
    Confirm,
    InfiniteTraderAndLocationAutoComplete,
    Viewer,
  },
  mixins: [
  ],
  props: {},
  data() {
    return {
      order: null,
      /** 営業担当者情報 */
      salesStaffs: [],
      /** 依頼元業者(収運業者)情報 */
      transports: null,
      selectedTransport: null,
      /** 引取場所選択情報 */
      selectedTraderLocation: null,
      /** 運搬先事業場 選択情報 */
      selectedToTraderLocation: null,
      /** 運搬先業者(収運 & 処分業者)情報 */
      enableRegistrationProvisionalDialog: false,
      traders: null,
      selectedTrader: null,
      files: [],
      /** 受注情報 */
      salesTableHeaders: [
        { value: 'sales_item_code', text: '売上品目コード', align: 'end' , width: '22.2%'},
        { value: 'sales_item_name', text: '売上品目名' , width: '22.2%'},
        { value: 'amount_of_acceptance', text: '受入量', align: 'end' , width: '22.2%'},
        { value: 'editable', text: '', align: 'end' , width: '33.4%'},
      ],
      salesItemPrices: [],
      salesItemUnits: [],
      totalAmountOfAcceptance: 0,
      acceptanceUnitName: null,
      /** 品目一覧の有無チェック (booleanだとエラー出力できないため、null か 1 で判別) */
      isSales: null,
      selectedSalesItem: null,
      enableSalesItemDialog: false,
      selectedTraderId: null,
      drivers: [],
      transportations: [],
      vehicles: [],
      viewerOptions: {
        inline: false,
        button: true,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: false,
        zoomable: false,
        rotatable: false,
        fullscreen: true,
      },
    }
  },
  computed: {
    ...mapState('DriverTenantConfiguration', {
      isBilling: 'use_billing',
    }),
    MANIFEST_ATTACHMENT() {
      return MANIFEST_ATTACHMENT
    },
    activeFiles () {
      return (this.files || []).filter((file) => !file._destroy)
    },
    driverInstructionMd () {
      const count = this.activeFiles.length

      if (count === 0) return 9
      if (count === 1) return 7
      if (count === 2) return 6
      return 5
    },
    attachmentViewerMd () {
      const count = this.activeFiles.length

      if (count === 0) return 0
      if (count === 1) return 2
      if (count === 2) return 3
      return 4
    },
    /**
     * フィルターした受注情報リストを返す.
     * 削除ボタン押下により_destroyが設定された行は非表示とする.
     * @return {*[]}
     */
    filteredSalesItems () {
      let filteredList = []
      if (this.order) {
        filteredList = this.order.order_pickup_details.filter(v => !v._destroy)
      }
      return filteredList
    },
  },
  watch: {
    filteredSalesItems () {
      this.calculateTotalAmount()
    },
  },
  created() {
    this.fetchSalesStaffs().then((content) => {
      this.salesStaffs = content.sales_staffs
    })

    this.fetchSalesItemUnits().then((content) => {
      this.salesItemUnits = content.sales_item_units
    })
    this.fetchDrivers({without_invisible: true}).then((content) => { this.drivers = content.drivers })
    this.fetchTransportations().then((content) => {
      this.transportations = content.transportations
    })
    this.fetchVehicles({ registered_number: true}).then((content) => { this.vehicles = content.vehicles })
    if (this.$route.params.duplicate_id) {
      this.fetchDuplicateOrder({id: this.$route.params.duplicate_id}).then((content) => {
        this.order = content
        this.selectedTransport = content.transport
        this.selectedTransportId = content.transport.id
        this.selectedTraderLocation = content.trader_location
        this.selectedToTraderLocation = content.trader_location
        this.selectedTrader = content.trader
        this.replacementSalesItemPrices(content.request_trader_id)
        if (this.$route.query.plan_date) {
          this.order.plan_date = this.$route.query.plan_date;
        }
      })
    } else {
      this.fetchNewOrder().then((content) => {
        this.order = content
        if (this.$route.query.plan_date) {
          this.order.plan_date = this.$route.query.plan_date;
        }
      })
    }
  },
  methods: {
    ...mapActions('DriverOrderAcceptPickup', {
      fetchNewOrder: 'new',
      fetchDuplicateOrder: 'duplicate',
      createPickup: 'create',
    }),
    ...mapActions('DriverMasterSearchSupplierSalesItemPriceDetail', {
      fetchSalesItemPrices: 'index'
    }),
    ...mapActions('snackbar', {
      showError: 'showError',
    }),
    ...mapActions('DriverMasterSearchSalesStaff', {
      fetchSalesStaffs: 'index',
    }),
    ...mapActions('DriverMasterSearchSalesItemUnit', {
      fetchSalesItemUnits: 'index',
    }),
    ...mapActions('snackbar', {
      showError: 'showError',
    }),
    ...mapActions('DriverMasterSearchDriver', {
      fetchDrivers: 'index',
    }),
    ...mapActions('DriverMasterSearchTransportation', {
      fetchTransportations: 'index'
    }),
    ...mapActions('DriverMasterSearchVehicle', {
      fetchVehicles: 'search',
    }),
    ...mapActions("DriverMasterSearchTraderMember", {
      fetchTrader: "show",
    }),
    ...mapActions("DriverMasterSearchTraderLocationMember", {
      fetchTraderLocation: "show",
    }),
    /**
     * 依頼元業者 チェンジイベント
     */
    requestTraderChangeEvent () {

      // 依頼元業者 事業者が選択済み
      if (this.order.request_trader_id) {

        // (既に依頼元業者(事業者)が選択済みで、今回選択した事業者と不一致) で、受注情報が登録済みの場合
        // 選ぶことができる売上品目が変わるので、確認メッセージを表示
        if ((this.selectedTraderId && this.order.request_trader_id !== this.selectedTraderId) && this.filteredSalesItems.length > 0) {

          let modalOption = { title: '確認', message: '依頼元業者が変更されたので受注情報をクリアします。よろしいですか？', options: { width: 400, isCancelButton: true } }
          this.$refs.confirm.open(modalOption).then((confirm) => {
            this.$refs.confirm.close()
            if (confirm) {
              // クリアOKであれば全ては気

              for (let i = 0; i < this.order.order_pickup_details.length; i++) {
                this.order.order_pickup_details[i]._destroy = true
              }
              // this.order.trader_location_code = null;
              // this.order.trader_location_id = null;
              this.replacementSalesItemPrices(this.order.request_trader_id)
              this.selectedTraderId = this.order.request_trader_id
            } else {
              // クリアしなのであれば業者を戻す

              this.order.request_trader_id = this.selectedTraderId
            }
          })

        } else {
          /*
           * 依頼元未選択 OR
           */
          this.selectedTraderId = this.order.request_trader_id

          this.replacementSalesItemPrices(this.order.request_trader_id)
        }
      }
    },
    replacementSalesItemPrices (trader_id) {
      this.salesItemPrices = []
      if (trader_id) {
        this.loadSalesItemPrices(trader_id)
      }
    },
    showSalesDialogButtonClickEvent () {
      this.selectedSalesItem = null
      this.enableSalesItemDialog = true
    },
    /**
     * 編集ボタン クリックイベント
     * @param item
     */
    editButtonClickEvent (item) {
      this.selectedSalesItem = _.cloneDeep(item)
      this.enableSalesItemDialog = true
    },

    dialogCancelCallback () {
      this.selectedSalesItem = null
      this.enableSalesItemDialog = false
    },
    dialogRegisterCallback (item) {
      let detail = this.order.order_pickup_details.find(v => v.key === item.key)
      if (detail) {
        Object.assign(detail, item)
      } else {
        this.order.order_pickup_details.push(item)
      }
      this.calculateTotalAmount()
      this.dialogCancelCallback()
    },
    /**
     * 運搬担当者 チェンジイベント
     */
    transportUserChangeEvent (item) {
      const transportUser = this.drivers.find( (v) => v.text.replace(/\s+/g,'') === item.replace(/\s+/g,''))
      if (transportUser) {
        this.order.transport_user_id = transportUser.value
      } else {
        this.order.transport_user_id = null
      }
    },
    /**
     * 運搬担当者クリア クリックイベント
     */
    transportUserClearClickEvent () {
      this.order.transport_user_id = null
      this.order.transport_user_name = null
    },
    /**
     * 削除ボタン クリックイベント
     */
    deleteButtonClickEvent (item) {
      let modalOption = { title: '削除', message: '削除しますがよろしいですか？', options: { width: 320, titleColor: 'red', isCancelButton: true } }
      this.$refs.confirm.open(modalOption).then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          for (const sales_item of this.order.order_pickup_details) {
            if (sales_item.key === item.key) {
              sales_item._destroy = true
            }
          }
          this.calculateTotalAmount()
        }
      })
    },
    /**
     * キャンセルボタン クリックイベント
     */
    cancelButtonClickEvent () {
      this.$router.push( { name: 'DriverOrderAccepts' } )
    },
    /**
    * 受注登録ボタン クリックイベント
    */
    registerButtonClickEvent () {
      return new Promise((resolve) => {
        setTimeout(() => {
          this.$refs.orderAcceptsPickupValidator.validateWithInfo().then(({ isValid, errors }) => {
            if (isValid) {
              this.enableRegistrationProvisionalDialog = true
            } else {
              let messages = []
              for (let key in errors) {
                if (errors[key].length > 0) {
                  messages.push(errors[key][0])
                }
              }
              this.showError({ message: messages.join(',') })
            }
          })
          resolve();
        }, 1000);
      });
    },
    /**
     * 登録モーダルからの戻り
     * @param afterTransaction { Boolean }　true: 売上入力へ, false: 一覧へ
     */
    registrationProvisionalRegisterCallback (afterTransaction) {
      const params = this.buildParams()
      this.createPickup({ id: this.$route.params.id, params: params }).then((content) => {
        if (afterTransaction) { // OKして売上入力へ進む
          this.$router.push({name: 'DriverSalesTransactionEdit', params: { id: content.deal.id }})
        } else { // OKして閉じる(一覧画面に戻る)
          this.$router.push({ name: 'DriverOrderAccepts' })
        }
      })
    },
    registrationProvisionalDialogCloseCallback () {
      this.enableRegistrationProvisionalDialog = false
    },
    buildParams () {
      const params = new FormData()

      /* 売上計上しない */
      params.append('not_recorded_sales', this.nullToBlank(this.order.not_recorded_sales))
      /* 営業担当者 */
      params.append('sales_staff', this.nullToBlank(this.order.sales_staff))

      /* 依頼元事業者ID */
      params.append('order_pickup_attributes[request_trader_id]', this.order.request_trader_id)
      /* 引取場所事業場コード */
      params.append('order_pickup_attributes[trader_location_code]', this.order.trader_location_code)

      /* 運搬先事業者ID */
      params.append('order_pickup_attributes[trader_id]', this.order.trader_id)
      /* 運搬先事業場コード */
      params.append('order_pickup_attributes[to_trader_location_code]', this.order.to_trader_location_code)

      /* 積替運搬日 */
      params.append('plan_date', this.nullToBlank(this.order.plan_date))
      /* 希望開始時間 */
      params.append('plan_start_time', this.nullToBlank(this.order.plan_start_time))
      /* 希望終了時間 */
      params.append('plan_end_time', this.nullToBlank(this.order.plan_end_time))

      /* 運搬担当者 */
      params.append('transport_user_id', this.nullToBlank(this.order.transport_user_id))
      params.append('transport_user_name', this.nullToBlank(this.order.transport_user_name))
      /* 運搬方法　*/
      params.append('transportation_id', this.nullToBlank(this.order.transportation_id))
      /* 車両名 */
      params.append('vehicle_number', this.nullToBlank(this.order.vehicle_number))

      /* ドライバー指示メモ */
      params.append('driver_instruction', this.nullToBlank(this.order.driver_instruction))

      /* オーダー 添付ファイル*/
      for (const file of this.files) {
        // 新規 or 削除対象のみ
        if (!file.file && !file._destroy) continue

        if (file.id) {
          params.append('order_attachments_attributes[][id]', file.id)
        }
        params.append('order_attachments_attributes[][file]', file.file)
        if (file._destroy) {
          params.append('order_attachments_attributes[][_destroy]', file._destroy)
        }
      }

      /* 検索キーワード */
      params.append('keyword', this.nullToBlank(this.order.keyword))

      /* 積替運搬日 */
      params.append('order_pickup_attributes[request_date]', this.nullToBlank(this.order.plan_date))
      /* 引取希望開始時間 */
      params.append('order_pickup_attributes[preferred_start_time]', this.nullToBlank(this.order.plan_start_time))
      /* 引取希望終了時間 */
      params.append('order_pickup_attributes[preferred_end_time]', this.nullToBlank(this.order.plan_end_time))

      /* オーダー引取詳細 */
      if (this.isBilling && !this.order.not_recorded_sales) {
        this.order.order_pickup_details.forEach((order_pickup_detail, index) => {
          /* 売上品目コード */
          params.append(`order_pickup_attributes[order_pickup_details_attributes][${index}][sales_item_price_code]`, this.nullToBlank(order_pickup_detail.sales_item_code))
          /* 売上品目名 */
          params.append(`order_pickup_attributes[order_pickup_details_attributes][${index}][sales_item_price_name]`, this.nullToBlank(order_pickup_detail.sales_item_name))
          /* 受入量 */
          params.append(`order_pickup_attributes[order_pickup_details_attributes][${index}][received_quantity]`, this.nullToBlank(order_pickup_detail.amount_of_acceptance))
          /* 受入量単位 */
          params.append(`order_pickup_attributes[order_pickup_details_attributes][${index}][sales_item_unit_id]`, this.nullToBlank(order_pickup_detail.amount_of_acceptance_unit_id))
          /* 削除 */
          params.append(`order_pickup_attributes[order_pickup_details_attributes][${index}][_destroy]`, this.nullToBlank(order_pickup_detail._destroy))

        })
      }

      return params
    },
    loadSalesItemPrices (trader_id) {
      if (trader_id) {
        this.fetchSalesItemPrices({id: trader_id, type: 'Trader', only_jwnet_item: true}).then((content) =>{
          this.salesItemPrices = content.sales_item_price_details
        })
      }
    },
    /**
     * 受入量合計の算出
     */
    calculateTotalAmount () {
      this.totalAmountOfAcceptance = 0
      // 受入量単位あり かつ 表示中のリスト
      let isAcceptanceUnitList = this.order.order_pickup_details.filter(v => v.amount_of_acceptance_unit_name !== null && !v._destroy)
      if (isAcceptanceUnitList.length > 0) {

        let acceptanceUnitAllEqual = isAcceptanceUnitList.every(v => v.amount_of_acceptance_unit_name === isAcceptanceUnitList[0].amount_of_acceptance_unit_name)
        if (acceptanceUnitAllEqual) {
          // 受入量合計 単位
          this.acceptanceUnitName = isAcceptanceUnitList[0].amount_of_acceptance_unit_name
          // 受入量合計
          for (const sales_item of isAcceptanceUnitList) {
            this.totalAmountOfAcceptance += parseFloat(sales_item.amount_of_acceptance)
          }
        }
      }
    },

    /**
     * 依頼元業者 チェンジコールバック
     * @param trader_id { Number }
     * @param location_id { Number }
     * @param location_code { String }
     */
    requestTraderChangedCallback(trader_id, location_id, location_code) {
      this.order.request_trader_id = trader_id;
      this.order.trader_location_id = location_id;
      this.order.trader_location_code = location_code;
      this.requestTraderChangeEvent();
      this.loadRequestTrader();
      this.loadRequestTraderLocation();
    },
    /**
     * 依頼元業者 選択ボタンからのダイアログのコールバック
     * @param item
     */
    choseRequestTraderCallback (item) {
      this.order.request_trader_id = item.id;
      this.order.trader_location_id = null;
      this.order.trader_location_code = null;
      this.requestTraderChangeEvent();
      this.loadRequestTrader();
      this.loadRequestTraderLocation();
    },
    loadRequestTrader () {
      this.selectedTransport = null;
      if (!this.order.request_trader_id) {
        return;
      }
      this.fetchTrader({ id: this.order.request_trader_id }).then((content) => {
        this.selectedTransport = content;
      })
    },
    loadRequestTraderLocation () {
      this.selectedTraderLocation = null;
      if (!this.order.trader_location_id) {
        return;
      }
      this.fetchTraderLocation({ id: this.order.trader_location_id }).then((content) => {
        this.selectedTraderLocation = content;
      })
    },
    /**
     * 運搬先事業者 チェンジコールバック
     * @param trader_id { Number }
     * @param location_id { Number }
     * @param location_code { String }
     */
    toTraderChangedCallback (trader_id, location_id, location_code) {
      this.order.trader_id = trader_id;
      this.order.to_trader_location_id = location_id;
      this.order.to_trader_location_code = location_code;
      this.loadTrader();
      this.loadToTraderLocation();
    },
    /**
     * 運搬先事業者 選択ボタンからのダイアログのコールバック
     * @param item
     */
    choseTraderCallback (item) {
      this.order.trader_id = item.id;
      this.order.to_trader_location_id = null;
      this.order.to_trader_location_code = null;
      this.loadTrader();
    },

    loadTrader () {
      this.selectedTrader = null;
      if (!this.order.trader_id) {
        return;
      }
      this.fetchTrader({ id: this.order.trader_id }).then((content) => {
        this.selectedTrader = content;
      })
    },
    loadToTraderLocation () {
      this.selectedToTraderLocation = null;
      if (!this.order.to_trader_location_id) {
        return;
      }
      this.fetchTraderLocation({ id: this.order.to_trader_location_id }).then((content) => {
        this.selectedToTraderLocation = content;
      })
    },
    /**
     * 積替運搬日変更　コールバック
     */
    planDateChangedCallback (value) {
      this.order.plan_date = value;
    },

    /**
     * ファイル種別が画像であるかの判定
     * @param type
     * @return { boolean }
     */
    isImageContent (type) {
      return type.startsWith('image')
    },
    /**
     * ファイル種別がPDFであるかの判定
     * @param type
     * @return { boolean }
     */
    isPdfContent (type) {
      return type.endsWith('pdf')
    },
    documentIcon(type) {
      return (this.isPdfContent(type)) ? "mdi-file-pdf-box" : "mdi-file-document-outline"
    },
    removeFile (file) {
      if (!file) return
      file._destroy = true
    },
    isEmpty (val) {
      return (val === null || val === '')
    },
  }
}

</script>

<style scoped lang="scss">
.image-wrapper {
  border: 1px solid #ddd ;
  border-radius: 5px;
  display: inline-block;
  float: left;
  margin: 3px;
  padding: 0;
  .image {
    height: 150px;
    cursor: pointer;
    padding: 0;
    border: none;
  }
}
</style>
